import * as React from 'react';
import { ColumnProps } from 'antd/lib/table';
import { Account, SlimApplication } from 'Core/Api/Api';
import SimpleTable from 'components/Forms/DataGrid/SimpleTable';
import { ClientApplicationHandler } from '../../ClientApplicationHandler';
import { NavLink } from 'react-router-dom';
import DetailsData from 'Core/models/DetailsData';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import DetailsMode from '../../../../Core/models/DetailsMode';
import { startCase } from 'lodash';
import NumberFormat from 'react-number-format';
import moment, { isMoment } from 'moment';

export interface Props {
    children?: React.ReactNode;
}

export interface State {
    countries: IFilterSelectOption[];
    jurisdictions: IFilterSelectOption[];
    roles: IFilterSelectOption[];
}

export default class IpoApplicationListTable extends React.Component<Props, State> {
    handler: ClientApplicationHandler;

    constructor(props: Props) {
        super(props);

        this.state = {
            countries: [],
            jurisdictions: [],
            roles: [],
        };
        this.handler = new ClientApplicationHandler(props);
    }

    componentDidMount() {

    }

    userListTableColumns: Array<ColumnProps<SlimApplication>> = [
        {
            title: 'Application Number',
            dataIndex: 'applicationNumber',
            sorter: false,
        },
        {
            title: 'Offering',
            dataIndex: 'offeringName',
            sorter: false,
        },
        {
            title: 'Account Number',
            dataIndex: 'accountNumber',
            sorter: false,
        },
        {
            title: 'Share Pool',
            dataIndex: 'sharePoolName',
            sorter: false,
        },
        {
            title: 'Shares Requested',
            dataIndex: 'sharesRequested',
            sorter: false,
            render: (text: any, record: SlimApplication, index: number) => {
                return (
                    <div style={{ textAlign: 'left' }} >
                        <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                    </div>
                );
            },
        },
        {
            title: 'Price',
            dataIndex: 'price',
            sorter: false,
            render: (text: any, record: SlimApplication, index: number) => {
                return (
                    <div style={{ textAlign: 'left' }} >
                        <NumberFormat value={text} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} />
                    </div>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text: any, record: SlimApplication, index: number) => {
                return (
                    <div>
                        {startCase(text)}
                    </div>
                );
            },
        },
        {
            title: 'Date Submitted',
            dataIndex: 'submittedDate',
            render: (text: any, record: SlimApplication, index: number) => {
                var submitted = moment(text);
                return (
                    <div>
                        {submitted.isValid() ? submitted?.format('MMMM D YYYY') : 'N/A'}
                    </div>
                );
            },
        },
        {
            title: '',
            render: (text: any, record: SlimApplication, index: number) => {
                return (
                    <NavLink
                        to={{
                            pathname: 'applications/' + record.id,
                            state: new DetailsData(DetailsMode.View, record.id),
                        }}>
                        View
                    </NavLink>
                );
            },
        },
    ];

    render() {
        return (
            <SimpleTable<SlimApplication>
                scroll={{ x: true }}
                tableKey="id"
                dataFetcher={this.handler}
                columns={this.userListTableColumns}

            />
        );
    }
}



